module.exports = __webpack_public_path__ + "img/copy-right@3x.5ac9114b.png";